/**
 * @generated SignedSource<<7f7deb44db082637a0a77bebb5cdba91>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmployeeEditPhoto_employee$data = {
  readonly id: string;
  readonly image: {
    readonly " $fragmentSpreads": FragmentRefs<"ImagePublicOrPrivate_image">;
  } | null;
  readonly " $fragmentType": "EmployeeEditPhoto_employee";
};
export type EmployeeEditPhoto_employee$key = {
  readonly " $data"?: EmployeeEditPhoto_employee$data;
  readonly " $fragmentSpreads": FragmentRefs<"EmployeeEditPhoto_employee">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployeeEditPhoto_employee",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ImagePublicOrPrivate_image"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Employee",
  "abstractKey": null
};

(node as any).hash = "0332870eab2da0d9f5b676415c13e4b6";

export default node;
